module.exports = __webpack_public_path__ + "static/cassieprogram-bc37367c695492cd6ba751a8e2b6ac35.pdf";